import React, { useState, useEffect, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { YMaps, Map, Placemark, SearchControl } from '@pbe/react-yandex-maps';
import { Modal } from 'react-bootstrap'
import { httpOk, POST } from 'helpers/api';

function Index({ modalMap, newAddress, setNewAddress, toggleModalMap, createClientAddress }) {
	const { t } = useTranslation()

	const reduxDelivery = useSelector(state => state.delivery)

	const ymaps = React.useRef(null)

	const [defaultState, setDefaultState] = useState({
		center: [41.311081, 69.240562],
		zoom: 11,
		controls: ["zoomControl"]
	});

	async function findClosestPos(obj = { 'latitude': '', 'longitude': '', 'full_address': '', 'short_address': '' }) {
		const response = await POST('/delivery/closest-pos', {
			"latitude": obj.latitude,
			"longitude": obj.longitude,
			"address": obj.address,
		}, { loader: true })

		if (httpOk(response)) {
			setNewAddress({
				...newAddress,
				'latitude': obj.latitude,
				'longitude': obj.longitude,
				'new_address': obj.address,
				'address': obj.address,
				'full_address': obj.full_address ?? "",
				'short_address': obj.short_address ?? "",
				'pos_id': response.data.id,
				'pos_name': response.data.name,
				'distance': response.data.distance,
			})
		}
	}

	useEffect(() => {
		if (reduxDelivery?.poses.length > 0 && reduxDelivery?.poses[0]['longitude']) {
			setDefaultState({
				center: [reduxDelivery?.poses[0]['latitude'], reduxDelivery?.poses[0]['longitude']],
				zoom: 11,
				controls: ["zoomControl"]
			})
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={modalMap}
				animation={false}
				dialogClassName="custom-delivery-modal"
				backdrop="static"
				onHide={() => toggleModalMap()}>
				<Modal.Body>
					<div className="row">
						<div className="col-md-12" style={{ height: '80vh' }}>
							{console.log(newAddress)}
							<YMaps
								style={{ height: '80vh' }}
								query={{
									load: "package.full",
									apikey: 'b5de12cc-6217-4b13-9078-2e99c84df330'
								}}>
								<Map
									style={{ height: '80vh' }}
									defaultOptions={{
										copyrightUaVisible: false,
										yandexMapDisablePoiInteractivity: true,
									}}
									defaultState={defaultState}
									onLoad={(e) => {
										ymaps.current = e;
									}}
									onClick={async (event) => {
										const coords = event.get("coords");

										if (!ymaps.current) return;

										const res = await ymaps.current.geocode(coords);
										const firstGeoObject = res.geoObjects.get(0);

										// Полный адрес
										const fullAddress = firstGeoObject.getAddressLine();

										// Название населённого пункта (например, "Ташкент")
										const locality = firstGeoObject.getLocalities()[0] || "";

										// Улица и дом (например, "улица Афросиаб, 12")
										const street = firstGeoObject.getThoroughfare() || "";
										const house = firstGeoObject.getPremiseNumber() || "";

										// Короткий адрес: например "улица Афросиаб, 12"
										let shortAddress = [street, house].filter(Boolean).join(", ");

										// Если улицы нет — подставим город
										if (!shortAddress) {
											shortAddress = locality || fullAddress;
										}

										findClosestPos({
											'latitude': coords[0],
											'longitude': coords[1],
											'full_address': fullAddress,
											'short_address': shortAddress,
										});
									}}>
									{newAddress?.latitude &&
										<Placemark geometry={[newAddress.latitude, newAddress.longitude]} />
									}
									{reduxDelivery?.poses.map((item, index) => (
										<Placemark
											key={index}
											options={{ preset: 'islands#redStretchyIcon' }}
											properties={{
												// Используем balloonContent для отображения текста
												// В режиме по умолчанию balloonContent показывается по клику
												// Но мы можем сделать его открытым постоянно, если это нужно
												iconContent: item.name,
												intContent: t('pos'),
												balloonContent: `
													<div className="d-flex flex-column gap-3">
														<div>
															<div class="d-flex gap-2">
																<i class="uil uil-restaurant"></i>
																<span>${item.name}</span>
															</div>
															<div class="d-flex gap-2">
																<i class="uil uil-phone"></i>
																<span>${item.phone}</span>
															</div>
														</div>
													</div>
												`
											}}
											geometry={[Number(item.latitude), Number(item.longitude)]} />
									))}
									<SearchControl
										instanceRef={(initRef) => {
											if (initRef) {
												initRef.events.add('resultselect', async (e) => {
													var index = initRef.getSelectedIndex(e);
													var result = await initRef.getResult(index);

													// ✅ Используем сохранённый ymaps
													if (!ymaps.current) return;

													const coords = result.geometry.getCoordinates(); // координаты

													const res = await ymaps.current.geocode(coords);
													const firstGeoObject = res.geoObjects.get(0);

													// Полный адрес
													const fullAddress = firstGeoObject.getAddressLine();

													// Название населённого пункта (например, "Ташкент")
													const locality = firstGeoObject.getLocalities()[0] || "";

													// Улица и дом (например, "улица Афросиаб, 12")
													const street = firstGeoObject.getThoroughfare() || "";
													const house = firstGeoObject.getPremiseNumber() || "";

													// Короткий адрес: например "улица Афросиаб, 12"
													let shortAddress = [street, house].filter(Boolean).join(", ");

													// Если улицы нет — подставим город
													if (!shortAddress) {
														shortAddress = locality || fullAddress;
													}

													findClosestPos({
														'latitude': coords[0],
														'longitude': coords[1],
														'full_address': fullAddress,
														'short_address': shortAddress,
													});
												})
											}
										}}
										options={{
											position: {
												top: '10px',
												left: '34%',
											},
											fitMaxWidth: true,
											noPlacemark: true,
											maxWidth: '500px'
										}}
										style={{
											height: '50px',
										}}
									/>
								</Map>
							</YMaps>
						</div>
					</div>
					<div className="d-flex w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100 me-2" style={{ 'flex': 1 }}
							onClick={() => toggleModalMap()}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100" style={{ 'flex': 3 }}
							onClick={() => createClientAddress()}>
							<span>{t('save')}</span>
						</button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index